module.exports = __webpack_public_path__ + "img/heating-control-md.a735e41f.svg";